// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.researcherdashboard_dashboard_container__31ycS{
    display: flex;
    align-content: flex-start; 
    flex-direction: row;
    gap: 4rem;
    align-items: flex-start;
}

.researcherdashboard_dashboard_content__vM1km{
    display: flex;
    flex: 8 1;
    flex-direction: column;
    gap: 0.65rem;
}

.researcherdashboard_link__1S3lH{
    text-decoration: none;
    color: inherit;
}`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/researcherdashboard.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,SAAO;IACP,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB","sourcesContent":[".dashboard_container{\r\n    display: flex;\r\n    align-content: flex-start; \r\n    flex-direction: row;\r\n    gap: 4rem;\r\n    align-items: flex-start;\r\n}\r\n\r\n.dashboard_content{\r\n    display: flex;\r\n    flex: 8;\r\n    flex-direction: column;\r\n    gap: 0.65rem;\r\n}\r\n\r\n.link{\r\n    text-decoration: none;\r\n    color: inherit;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard_container": `researcherdashboard_dashboard_container__31ycS`,
	"dashboard_content": `researcherdashboard_dashboard_content__vM1km`,
	"link": `researcherdashboard_link__1S3lH`
};
export default ___CSS_LOADER_EXPORT___;
